import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introduction() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/talpool/introduction_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={815}
              height={521}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#EB2961" }}>Introduction</span>
            </h2>
            <p>
              It’s said ‘two heads are better than one’, and we couldn’t agree
              more. It isn’t just technology that we revolutionize; it’s the
              collective perspectives and practices that we bring to perfection
              along the way that marks our identity. With a team of experts, the
              ideas just came rolling and we made sure to deliver exceptional
              quality that speaks for itself.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introduction;
